<template>
  <LayoutDashboard title="Pedidos de Compra">
    <v-card outlined>
      <v-card-title>
        <v-btn
          color="primary"
          @click="cadastrarPedidoCompra"
          outlined
          v-if="$helper.verificaPermissao('cadastrar-pedido-compra')"
          >Cadastrar</v-btn
        >
        <v-spacer></v-spacer>
        <h3>Registros: {{ getPedidosCompras.total }} -</h3>
        <v-pagination
          outlined
          :total-visible="6"
          v-model="dataPagina.page"
          :length="getPedidosCompras.last_page"
          @input="(dataPagina.page = $event), debouncedListar()"
        ></v-pagination>
      </v-card-title>
      <v-card-text>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th width="8%">
                  <v-text-field
                    label="Cód"
                    v-model="dataPagina.id"
                    outlined
                    dense
                    class="mt-2"
                    @input="debouncedListar()"
                    type="numer"
                  ></v-text-field>
                </th>
                <th>
                  <v-text-field
                    label="Fornecedor"
                    v-model="dataPagina.fornecedor"
                    outlined
                    dense
                    class="mt-2"
                    @input="debouncedListar()"
                  ></v-text-field>
                </th>
                <th>Total</th>
                <th width="8%">
                  <v-text-field
                    label="Data"
                    v-model="dataPagina.data"
                    outlined
                    dense
                    class="mt-2"
                    @input="debouncedListar()"
                    type="date"
                  ></v-text-field>
                </th>
                <th width="8%">
                  <v-select
                    :items="[10, 20, 30, 40, 50]"
                    v-model="dataPagina.limit"
                    label="Exibir"
                    outlined
                    dense
                    class="mt-2"
                    @input="debouncedListar()"
                  ></v-select>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="p in getPedidosCompras.data" :key="p.id">
                <td>{{ p.id }}</td>
                <td>{{ p.fornecedor ? p.fornecedor.nome : "" }}</td>
                <td>{{ $helper.formatReal(parseFloat(p.total)) }}</td>
                <td>{{ $helper.formatDate(p.created_at) }}</td>
                <td>
                  <TooltipButton
                    @click.native="
                      $router.push({
                        name: 'pedidoCompraEditar',
                        params: { id: p.id },
                      })
                    "
                    classButton="ml-2"
                    subtitle="Visualizar"
                    icon="search"
                    color="primary"
                    v-if="$helper.verificaPermissao('visualizar-pedido-compra')"
                  />
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <h3>Registros: {{ getPedidosCompras.total }} -</h3>
        <v-pagination
          outlined
          :total-visible="6"
          v-model="dataPagina.page"
          :length="getPedidosCompras.last_page"
          @input="(dataPagina.page = $event), debouncedListar()"
        ></v-pagination>
      </v-card-actions>
    </v-card>
  </LayoutDashboard>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
var _ = require("lodash");
export default {
  data() {
    return {
      dataPagina: {
        id: "",
        fornecedor: "",
        data: "",
        limit: 20,
        page: "",
      },
      //   search: "",
      //   headers: [
      //     { text: "#", value: "id", sortable: false },
      //     {
      //       text: "Fornecedor",
      //       align: "left",
      //       sortable: false,
      //       value: "fornecedor.nome",
      //     },
      //     { text: "Total", value: "_total", sortable: false },
      //     {
      //       text: "Data/Hora",
      //       align: "left",
      //       sortable: false,
      //       value: "data_hora",
      //     },
      //     { text: "Ações", value: "action", sortable: false },
      //   ],
    };
  },
  computed: {
    ...mapGetters(["getPedidosCompras"]),
  },
  methods: {
    ...mapActions(["listarPedidoCompra", "cadastrarPedidoCompra"]),
    listar() {
      this.listarPedidoCompra(this.dataPagina);
    },
  },
  created() {
    this.listarPedidoCompra(this.dataPagina);
    this.debouncedListar = _.debounce(this.listar, 300);
  },
};
</script>